<div class="d-flex flex-column gap-3">
    <!-- Loading -->
    <app-spinner *ngIf="displayedNotifications == null"></app-spinner>

    <div class="d-flex justify-content-end">
        <button class="btn btn-default" (click)="markNotificationsAsRead()">
            {{ "inbox.notifications.markAllAsRead.title" | transloco }}
        </button>
    </div>

    <ng-container *ngIf="displayedNotifications">
        <div class="alert alert-secondary" *ngIf="!displayedNotifications.length">
            {{'inbox.notifications.emptyList' | transloco}}
        </div>

        <div class="d-flex flex-column gap-2">
            <div *ngFor="let notification of displayedNotifications">
                <a [routerLink]="['/notifications', notification.id]" class="text-decoration-none text-dark">
                    <div class="shadow-sm p-3 bg-white d-block rounded d-felx flex-column gap-1">
                        <!-- Row for Title and Date -->
                        <div class="d-flex gap-2 justify-content-between">
                            <span class="h8">{{ notification.subject }}</span>
                            <div class="position-relative">

                                <span class="fs-4 mb-0 text-nowrap"
                                    [ngClass]="notification.isRead ? 'fw-regular' : 'fw-bold'">
                                    {{ notification.date | date: "dd.MM.yy | HH:mm" }}
                                </span>

                                <span *ngIf="!notification.isRead"
                                    class="activ-filter-status-indicator  rounded-circle p-1 position-absolute top-0 mt-1 start-100 translate-middle">
                                </span>
                            </div>

                        </div>

                        <!-- Row for News Text and Chevron Icon -->
                        <div class="d-flex justify-content-between align-items-center">
                            <p class="flex-grow-1 h8 fw-regular">
                                {{ notification.contentShort }}
                            </p>
                            <i class="fa fa-chevron-right text-primary ms-1"></i>
                        </div>
                    </div>
                </a>
            </div>
        </div>

        <div class="d-flex justify-content-center" *ngIf="hasMore">
            <button (click)="loadMoreNotifications()" [disabled]="isPreLoading" class="btn btn-default">
                {{ "home.showMore.title" | transloco }}
            </button>
        </div>

    </ng-container>
</div>